import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Link,
  makeStyles,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ThemeBreadcrumbs from '../FinancialData/Company/BreadCrumbs';
import { BreadCrumbLink } from '../FinancialData/Company/BreadCrumbs/BreadCrumbs';
import PhoneSupportCard from './PhoneSupportCard';

interface OwnProps {
  breadCrumbs: BreadCrumbLink[];
}

const AuthenticatedHelpPage: React.FunctionComponent<OwnProps> = ({ breadCrumbs }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box>
      <ThemeBreadcrumbs items={breadCrumbs} />
      <div className={classes.box}>
        <PhoneSupportCard className={clsx(classes.cardBlock, classes.bottomMargin)} />
        <Card className={clsx(classes.cardBlock, classes.bottomMargin)}>
          <CardHeader title={t('app:help.supportEmailTitle')} />
          <CardContent>
            <Typography>
              <a href={`mailto:${t('app:help.supportEmail')}`} target="_top">
                {t('app:help.supportEmail')}
              </a>
            </Typography>
          </CardContent>
        </Card>
        <Card className={classes.cardBlock}>
          <CardHeader title={t('app:help.manualTitle')} />
          <CardContent>
            <Typography>
              <p>
                <Link
                  href="/documents/RoyaltyRange CompID Database Financial Fields Dictionary 2025-08-25.pdf"
                  target="blank"
                >
                  {t('app:help.manualFiFieldsDict')}
                </Link>
              </p>
              <p>
                <Link
                  href="/documents/Long version ROYALTYRANGE CompID Financial Ratios Dictionary 2025-08-25.pdf"
                  target="blank"
                >
                  {t('app:help.manualFiRatiosDict')}
                </Link>
              </p>
              <p>
                <Link
                  href="/documents/ROYALTYRANGE CompID PLIs and WCA formulas 2025-04-23.pdf"
                  target="blank"
                >
                  {t('app:help.manualWcaFormulas')}
                </Link>
              </p>
              <p>
                <Link
                  href="/documents/RoyaltyRange CompID Filters Dictionary 2025-08-25.pdf"
                  target="blank"
                >
                  {t('app:help.manualFilterDict')}
                </Link>
              </p>
            </Typography>
          </CardContent>
        </Card>
      </div>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    padding: theme.spacing(5),
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bottomMargin: {
    marginBottom: theme.spacing(5),
  },
  cardBlock: {
    minWidth: '350px',
    '& .MuiCardHeader-root': {
      color: theme.palette.primary.dark,
      paddingBottom: theme.spacing(4),
    },
    '& .MuiCardContent-root': {
      paddingTop: 0,
    },
  },
}));

export default AuthenticatedHelpPage;
